import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { CdnImgModule } from "@webapp/shared/directives/cdn-img/cdn-img.module";
import { UiGridModule } from "@webapp/ui/grid/grid.module";
import { NothingFoundComponent } from "./nothing-found.component";

@NgModule({
  imports: [CommonModule, LocalizationModule, UiGridModule, CdnImgModule],
  declarations: [NothingFoundComponent],
  exports: [NothingFoundComponent],
})
export class NothingFoundModule {}
